import * as types from './weaveColorActionTypes';

export const getWeaveColorRequestAction = (payload) => ({
  type: types.GET_WEAVECOLOR_REQUEST,
  payload,
});
export const getWeaveColorDataAction = (payload) => ({
  type: types.GET_WEAVECOLOR_DATA,
  payload,
});
export const getWeaveColorErrorAction = (payload) => ({
  type: types.GET_WEAVECOLOR_ERROR,
  payload,
});

export const createWeaveColorRequestAction = (payload) => ({
  type: types.CREATE_WEAVECOLOR_REQUEST,
  payload,
});
export const createWeaveColorDataAction = (payload) => ({
  type: types.CREATE_WEAVECOLOR_DATA,
  payload,
});
export const createWeaveColorErrorAction = (payload) => ({
  type: types.CREATE_WEAVECOLOR_ERROR,
  payload,
});

export const updateWeaveColorRequestAction = (payload) => ({
  type: types.UPDATE_WEAVECOLOR_REQUEST,
  payload,
});
export const updateWeaveColorDataAction = (payload) => ({
  type: types.UPDATE_WEAVECOLOR_DATA,
  payload,
});
export const updateWeaveColorErrorAction = (payload) => ({
  type: types.UPDATE_WEAVECOLOR_ERROR,
  payload,
});

export const deleteWeaveColorRequestAction = (payload) => ({
  type: types.DELETE_WEAVECOLOR_REQUEST,
  payload,
});
export const deleteWeaveColorDataAction = (payload) => ({
  type: types.DELETE_WEAVECOLOR_DATA,
  payload,
});
export const deleteWeaveColorErrorAction = (payload) => ({
  type: types.DELETE_WEAVECOLOR_ERROR,
  payload,
});
